const PERMISSION_KEY= "personalize:ta_signal_config";
const PAGE_URL = {
    TA_SIGNAL_CONFIG_PAGE: "/admin/personalize/ta-signal-config"
}

export {PERMISSION_KEY, PAGE_URL}

